(function () {
  try {
    var done = false;

    function reveal() {
      if (done) return;
      done = true;
      document.body.classList.remove('samita-prelock');
    }

    function checkLock() {
      var params = window.Samita && window.Samita.SamitaLocksAccessParams;
      if (!params || !params.locks) return false;

      // Not a product page — reveal immediately
      if (!params.product) { reveal(); return true; }

      var productId = String(params.product.id);
      var cols = params.product.collections;
      var colIds = Array.isArray(cols) ? cols.map(String) : [String(cols)];

      var isLocked = params.locks.some(function (lock) {
        if (lock.status !== 1) return false;
        var r = lock.resources_lock;
        if (!r) return false;
        if (r.products && r.products[productId]) return true;
        if (r.collections) return colIds.some(function (c) { return r.collections[c]; });
        return false;
      });

      // Not a locked product — reveal immediately, no delay
      if (!isLocked) { reveal(); return true; }

      // Locked product — watch for Samita's modal
      var obs = new MutationObserver(function () {
        var modal = document.querySelector('.smt-modal-lock');
        if (!modal) return;
        obs.disconnect();

        // Modal appeared — keep ATC hidden, watch for auth completion
        var authObs = new MutationObserver(function () {
          var m = document.querySelector('.smt-modal-lock');
          if (!m || getComputedStyle(m).display === 'none') {
            reveal();
            authObs.disconnect();
          }
        });
        authObs.observe(document.body, {
          childList: true, subtree: true,
          attributes: true, attributeFilter: ['style', 'class']
        });
      });
      obs.observe(document.body, { childList: true, subtree: true });

      // Fallback: blockUntilPaint delays Samita until window.load + 1s
      // Wait for load, then give Samita 1.5s to show a modal before revealing
      window.addEventListener('load', function () {
        setTimeout(function () {
          if (!document.querySelector('.smt-modal-lock')) {
            reveal();
            obs.disconnect();
          }
        }, 1500);
      });

      return true;
    }

    // Try immediately — Samita data is inline in <head>
    if (!checkLock()) {
      var attempts = 0;
      var poll = setInterval(function () {
        if (checkLock() || ++attempts > 40) {
          clearInterval(poll);
          if (attempts > 40) reveal();
        }
      }, 50);
    }

    // Block cart adds while prelock is active
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.includes('/cart/add') && !done) {
        var modal = document.querySelector('.smt-modal-lock');
        if (document.body.classList.contains('samita-prelock') ||
            (modal && getComputedStyle(modal).display !== 'none')) {
          return Promise.resolve(new Response(
            JSON.stringify({ description: 'Please enter your passcode to add this product to cart.' }),
            { status: 422, headers: { 'Content-Type': 'application/json' } }
          ));
        }
      }
      return _fetch.apply(this, arguments);
    };

  } catch (e) {}
})();

